var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerspectiveGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1285,
    height: 320,
    viewBox: "0 0 1285 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476.149 1L1.00007 318.999",
    stroke: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.264 1L53.532 318.998",
    stroke: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492.378 1L100.982 318.998",
    stroke: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M500.493 1L144.322 318.998",
    stroke: "#B3B3B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M508.608 1L184.297 318.998",
    stroke: "#B3B3B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M516.722 1L221.487 318.998",
    stroke: "#B3B3B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M524.837 1L256.357 318.998",
    stroke: "#B3B3B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M532.952 1L289.276 318.998",
    stroke: "#B3B3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M541.066 1L320.55 318.998",
    stroke: "#B3B3B3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M549.181 1L350.428 318.998",
    stroke: "#B3B3B3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M557.295 1L379.121 318.998",
    stroke: "#B3B3B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M565.411 1L406.807 318.998",
    stroke: "#B3B3B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M573.525 1L433.637 318.998",
    stroke: "#B3B3B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M581.64 1L459.744 318.998",
    stroke: "#B3B3B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M589.755 1L485.244 318.998",
    stroke: "#B3B3B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M597.869 1L510.238 318.998",
    stroke: "#B3B3B3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M605.984 1L534.822 318.998",
    stroke: "#B3B3B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M614.099 1L559.078 318.998",
    stroke: "#B3B3B3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M622.213 1L583.087 318.998",
    stroke: "#B3B3B3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M630.328 1L606.921 318.998",
    stroke: "#B3B3B3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M638.442 1L630.694 318.999",
    stroke: "#B3B3B3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M646.557 1L654.306 318.999",
    stroke: "#B3B3B3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M654.672 1L678.079 318.998",
    stroke: "#B3B3B3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M662.787 1L701.913 318.998",
    stroke: "#B3B3B3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M670.902 1L725.922 318.998",
    stroke: "#B3B3B3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M679.016 1L750.178 318.998",
    stroke: "#B3B3B3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M687.131 1L774.762 318.998",
    stroke: "#B3B3B3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M695.246 1L799.757 318.998",
    stroke: "#B3B3B3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M703.36 1L825.256 318.998",
    stroke: "#B3B3B3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M711.476 1L851.364 318.998",
    stroke: "#B3B3B3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M719.59 1L878.194 318.998",
    stroke: "#B3B3B3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M727.704 1L905.879 318.998",
    stroke: "#B3B3B3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M735.819 1L934.572 318.998",
    stroke: "#B3B3B3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M743.933 1L964.449 318.998",
    stroke: "#B3B3B3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M752.048 1L995.724 318.998",
    stroke: "#B3B3B3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M760.163 1L1028.64 318.998",
    stroke: "#B3B3B3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M768.278 1L1063.51 318.998",
    stroke: "#B3B3B3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M776.393 1L1100.7 318.998",
    stroke: "#B3B3B3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M784.507 1L1140.68 318.998",
    stroke: "#B3B3B3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M792.622 1L1184.02 318.998",
    stroke: "#B3B3B3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M800.736 1L1231.47 318.998",
    stroke: "#B3B3B3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M808.852 1L1284 318.999",
    stroke: "#B3B3B3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M476.149 1H808.851",
    stroke: "#B3B3B3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M476.149 1H808.851",
    stroke: "#B3B3B3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M476.149 1H808.851",
    stroke: "#B3B3B3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M476.149 1H808.851",
    stroke: "#B3B3B3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M476.149 1H808.851",
    stroke: "#B3B3B3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M476.148 1H808.851",
    stroke: "#B3B3B3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M476.148 1H808.851",
    stroke: "#B3B3B3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M476.148 1.00098H808.852",
    stroke: "#B3B3B3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M476.147 1.00146H808.853",
    stroke: "#B3B3B3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M476.145 1.00269H808.855",
    stroke: "#B3B3B3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M476.141 1.00562H808.86",
    stroke: "#B3B3B3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M476.134 1.01025H808.867",
    stroke: "#B3B3B3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M476.122 1.01807H808.878",
    stroke: "#B3B3B3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M476.104 1.03027H808.897",
    stroke: "#B3B3B3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M476.076 1.04883H808.925",
    stroke: "#B3B3B3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M476.034 1.07666H808.966",
    stroke: "#B3B3B3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M475.974 1.11694H809.026",
    stroke: "#B3B3B3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M475.889 1.17383H809.111",
    stroke: "#B3B3B3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M475.772 1.25195H809.227",
    stroke: "#B3B3B3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M475.614 1.35791H809.386",
    stroke: "#B3B3B3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M475.402 1.49927H809.598",
    stroke: "#B3B3B3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M475.124 1.68579H809.876",
    stroke: "#B3B3B3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M474.762 1.92847H810.238",
    stroke: "#B3B3B3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M474.297 2.23926H810.703",
    stroke: "#B3B3B3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M472.965 3.13037H812.034",
    stroke: "#B3B3B3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M469.499 5.4502H815.501",
    stroke: "#B3B3B3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M465.736 7.96851H819.263",
    stroke: "#B3B3B3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M463.263 9.62427H821.738",
    stroke: "#B3B3B3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M460.309 11.6008H824.691",
    stroke: "#B3B3B3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M456.802 13.948H828.198",
    stroke: "#B3B3B3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 16.7207H832.341",
    stroke: "#B3B3B3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M447.789 19.98H837.212",
    stroke: "#B3B3B3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M442.09 23.7944H842.911",
    stroke: "#B3B3B3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M435.45 28.2383H849.55",
    stroke: "#B3B3B3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M427.747 33.3938H857.253",
    stroke: "#B3B3B3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M418.844 39.3516H866.156",
    stroke: "#B3B3B3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M408.593 46.2114H876.406",
    stroke: "#B3B3B3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M396.832 54.0833H888.168",
    stroke: "#B3B3B3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M383.383 63.0845H901.618",
    stroke: "#B3B3B3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M368.052 73.345H916.949",
    stroke: "#B3B3B3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M350.629 85.0051H934.371",
    stroke: "#B3B3B3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M330.887 98.2175H954.113",
    stroke: "#B3B3B3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M308.579 113.147H976.421",
    stroke: "#B3B3B3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M283.438 129.973H1001.56",
    stroke: "#B3B3B3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M255.177 148.887H1029.82",
    stroke: "#B3B3B3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M223.484 170.097H1061.52",
    stroke: "#B3B3B3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M188.028 193.827H1096.97",
    stroke: "#B3B3B3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M148.449 220.315H1136.55",
    stroke: "#B3B3B3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M104.364 249.819H1180.64",
    stroke: "#B3B3B3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3613 282.615H1229.64",
    stroke: "#B3B3B3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00098 318.996H1284",
    stroke: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspectiveGrid);
export default __webpack_public_path__ + "static/media/Perspective Grid.5a993cb573f3665720684630ca898242.svg";
export { ForwardRef as ReactComponent };